import { Body, Button } from '@e2n/ui/v2';
import { faCircleX } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotAuthorized() {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-4">
      <div className="size-12 bg-neutrals-v2-200 rounded-xl flex items-center justify-center">
        <FontAwesomeIcon
          icon={faCircleX}
          className="text-error-red-200 size-6"
        />
      </div>
      <div className="flex flex-col gap-1">
        <Body weight={'semibold'}>
          {t('domain.datev.page.connection.status.disconnected.text')}
        </Body>
        <Body>
          {t('domain.datev.page.connection.status.disconnected.description')}
        </Body>
      </div>
      <Button asChild variant={'primary-pill'}>
        <Link to={'/datev/login'} className="ml-auto">
          {t('domain.datev.page.connection.status.login')}
        </Link>
      </Button>
    </div>
  );
}
